import { render } from "./SecondaryButton.vue?vue&type=template&id=3387eac8&scoped=true&ts=true"
import script from "./SecondaryButton.vue?vue&type=script&lang=ts"
export * from "./SecondaryButton.vue?vue&type=script&lang=ts"

import "./SecondaryButton.vue?vue&type=style&index=0&id=3387eac8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3387eac8"]])

export default __exports__